<div class="totp-container">
  <p-card>
    <ng-template pTemplate="header">
      <div class="totp-card-header">
        <div class="totp-card-header__icon">
          <i class="pi pi-shield"></i>
        </div>
        <div class="totp-card-header__text">
          <h3 class="totp-card-header__title">Authentification &agrave; deux facteurs</h3>
          <span class="totp-card-header__sub">Microsoft Authenticator &middot; TOTP</span>
        </div>
      </div>
    </ng-template>

    @if (!totpEnabled && !showSetup) {
      <div class="totp-section">
        <div class="totp-info-banner">
          <i class="pi pi-lock totp-info-banner__icon"></i>
          <div class="totp-info-banner__body">
            <p class="totp-info-banner__title">S&eacute;curisez votre compte</p>
            <p class="totp-info-banner__desc">
              Activez l'authentification &agrave; deux facteurs pour prot&eacute;ger votre acc&egrave;s avec un code temporaire renouvel&eacute; toutes les 30 secondes.
            </p>
          </div>
        </div>

        <ul class="totp-feature-list">
          <li><i class="pi pi-check"></i> Protection contre les acc&egrave;s non autoris&eacute;s</li>
          <li><i class="pi pi-check"></i> Code temporaire g&eacute;n&eacute;r&eacute; toutes les 30 secondes</li>
          <li><i class="pi pi-check"></i> Compatible Microsoft Authenticator, Google Authenticator, Authy&hellip;</li>
        </ul>

        <div class="totp-section__action">
          <p-button
            label="Activer le TOTP"
            icon="pi pi-shield"
            [loading]="isLoading"
            (onClick)="initTotpSetup()"
            styleClass="primary-btn">
          </p-button>
        </div>
      </div>
    }

    @if (totpEnabled && !showSetup) {
      <div class="totp-section totp-section--center">
        <div class="totp-status-badge totp-status-badge--ok">
          <i class="pi pi-check-circle"></i>
          <span>TOTP activ&eacute;</span>
        </div>
        <p class="totp-status-desc">
          L'authentification &agrave; deux facteurs est active sur votre compte.
        </p>
        <p-button
          label="D&eacute;sactiver le TOTP"
          icon="pi pi-times"
          [loading]="isLoading"
          (onClick)="disableTotp()"
          styleClass="totp-btn-danger">
        </p-button>
      </div>
    }

    @if (showSetup) {
      <div class="totp-setup">
        <div class="totp-step">
          <div class="totp-step__label">
            <span class="totp-step__num">1</span>
            <span class="totp-step__title">Scannez le QR Code</span>
          </div>
          <p class="totp-step__desc">
            Ouvrez Microsoft Authenticator et scannez ce QR code avec l'application.
          </p>

          <div class="totp-qr-wrap">
            <div class="totp-qr-frame">
              <img [src]="qrCodeImage" alt="QR Code TOTP" class="totp-qr-img" />
            </div>
          </div>

          <div class="totp-manual">
            <p class="totp-manual__label">Ou saisissez manuellement ce code :</p>
            <div class="totp-secret">
              <code class="totp-secret__code">{{ secret }}</code>
              <p-button
                icon="pi pi-copy"
                [text]="true"
                [rounded]="true"
                size="small"
                (onClick)="copySecret()"
                pTooltip="Copier le secret"
                styleClass="totp-secret__copy">
              </p-button>
            </div>
            <p class="totp-manual__help">
              <i class="pi pi-info-circle"></i>
              Dans Microsoft Authenticator : <strong>+</strong> &rarr; Autre compte &rarr; Saisir le code manuellement
            </p>
          </div>
        </div>

        <div class="totp-divider"></div>

        <div class="totp-step">
          <div class="totp-step__label">
            <span class="totp-step__num">2</span>
            <span class="totp-step__title">Entrez le code de v&eacute;rification</span>
          </div>
          <p class="totp-step__desc">
            Entrez le code &agrave; 6 chiffres affich&eacute; dans votre application d'authentification.
          </p>

          <form [formGroup]="verificationForm" (ngSubmit)="enableTotp()">
            <div class="totp-otp-wrap">
              <p-inputOtp
                formControlName="code"
                [length]="6"
                [integerOnly]="true">
              </p-inputOtp>
            </div>

            <div class="totp-actions">
              <p-button
                label="Annuler"
                icon="pi pi-times"
                severity="secondary"
                [outlined]="true"
                (onClick)="cancelSetup()"
                type="button"
                styleClass="totp-btn-secondary">
              </p-button>
              <p-button
                label="V&eacute;rifier et activer"
                icon="pi pi-check"
                [loading]="isLoading"
                [disabled]="verificationForm.invalid"
                type="submit"
                styleClass="primary-btn">
              </p-button>
            </div>
          </form>
        </div>
      </div>
    }
  </p-card>
</div>
